import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useForm, Controller } from "react-hook-form";
import { globalServices } from "../../Services/global.service";
import Select from "react-select";
import { useHistory } from "react-router-dom";
import {
  numbersOnly,
  storeTag,
  lettersOnly,
  address,
} from "../../Config/Regex";
import Tooltip from "../Common/Tooltip";

const StoreData = (props) => {
  const goTo = (data) => {
    setCreateStoreData({
      description: data.description,
      tag: data.tag,
      type: data.type,
      footerNote: data.footerNote,
      street: data.street,
      streetNumber: data.streetNumber,
      streetNumberExtension: data.streetNumberExtension,
      city: data.city,
      postalNumber: data.postalNumber.value,
      countryId: data.countryId,
    });
    props.nextStep();
  };

  const back = () => {
    props.prevStep();
  };

  const history = useHistory();
  const { register, handleSubmit, errors, control, setValue } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
  });
  const { createStoreData, setCreateStoreData } = props;
  const { t: translator } = useTranslation();
  const [postOffices, setPostOffices] = useState([]);
  const [countries, setCountries] = useState([]);

  useEffect(() => {
    globalServices
      .getCountries()
      .then((res) => setCountries(res.data))
      .catch((err) => console.log(err));

    globalServices
      .getPostOffices()
      .then((data) => {
        setPostOffices(data.data);
      })
      .catch(() => history.push("/Error"));
  }, []);

  const getCity = (id, label) => {
    globalServices
      .getCityByPostOffice(id)
      .then((res) => {
        setValue("city", res.data.data.name, { shouldValidate: true });
      })
      .catch(() => history.push("/Error"));
  };

  return (
    <>
      <div className="row">
        <div className="col-lg-4">
          <fieldset className="scheduler-border">
            <legend className="scheduler-border">
              {" "}
              {translator("Onboarding-StoreData-MainData")}
            </legend>
            <div className="form-group">
              <label> {translator("StoreAdd-Description")}</label>{" "}
              <Tooltip text={translator("StoreDataDescription-Msg")} />
              <textarea
                id="textArea"
                rows="2"
                className="form-control"
                name="description"
                ref={register({ required: true, maxLength: 100 })}
                defaultValue={createStoreData.description}
              />
              {errors.description && errors.description.type === "required" && (
                <p className="text-danger">
                  {translator("ValidationMsg-RequiredField")}
                </p>
              )}
              {errors.description &&
                errors.description.type === "maxLength" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-MaxLength100")}
                  </p>
                )}
            </div>
            <div className="form-group">
              <label htmlFor="tag">
                {" "}
                {translator("Onboarding-StoreData-StoreTag")}
              </label>{" "}
              <Tooltip text={translator("StoreDataTag-Msg")} />
              <input
                type="text"
                className="form-control"
                name="tag"
                ref={register({
                  //required: true,
                  pattern: storeTag,
                })}
                defaultValue={createStoreData.tag}
              />
              {/* {errors.tag && errors.tag.type === "required" && (
                <p className="text-danger">
                  {translator("ValidationMsg-RequiredField")}
                </p>
              )} */}
              {errors.tag && errors.tag.type === "pattern" && (
                <p className="text-danger">
                  {translator("ValidationMsg-StoreTag")}
                </p>
              )}
            </div>
            <div className="form-group">
              <label htmlFor="type">
                {translator("Onboarding-StoreData-StoreType")}
              </label>
              <select
                className="form-control"
                name="type"
                ref={register({ required: true })}
                defaultValue={createStoreData.type}
              >
                <option value="" disabled>
                  {translator("Onboarding-StoreData-SelectType")}
                </option>
                <option value="1">
                  {translator("StoreUpdate-SelectOption-Mobile")}
                </option>
                <option value="2">
                  {translator("StoreUpdate-SelectOption-Fixed")}
                </option>
              </select>
              {errors.type && errors.type.type === "required" && (
                <p className="text-danger">
                  {translator("ValidationMsg-RequiredField")}
                </p>
              )}
            </div>
            <div className="form-group">
              <label htmlFor="footerNote">
                {" "}
                {translator("Onboarding-StoreData-Note")}
              </label>{" "}
              <Tooltip text={translator("StoreDataNote-Msg")} />
              <input
                type="text"
                className="form-control"
                name="footerNote"
                ref={register({ required: true, maxLength: 250 })}
                defaultValue={createStoreData.footerNote}
              />
              {errors.footerNote && (
                <>
                  {errors.footerNote.type === "required" && (
                    <p className="text-danger">
                      {translator("ValidationMsg-RequiredField")}
                    </p>
                  )}
                  {errors.footerNote.type === "maxLength" && (
                    <p className="text-danger">
                      {translator("ValidationMsg-MaxLength250")}
                    </p>
                  )}
                </>
              )}
            </div>
          </fieldset>
        </div>
        <div className="col-lg-4">
          <fieldset className="scheduler-border">
            <legend className="scheduler-border">
              {translator("Onboarding-StoreData-AdressInformation")}
            </legend>
            <div className="form-container">
              <div className="form-group">
                <label htmlFor="storeStreet">
                  {translator("Onboarding-StoreData-Street")}
                </label>{" "}
                <Tooltip text={translator("StoreDataStreet-Msg")} />
                <input
                  type="text"
                  className="form-control"
                  name="street"
                  ref={register({
                    required: true,
                    maxLength: 150,
                    pattern: address,
                  })}
                  defaultValue={createStoreData.street}
                />
                {errors.street && errors.street.type === "required" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-RequiredField")}
                  </p>
                )}
                {errors.street && errors.street.type === "pattern" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-LettersOnly")}
                  </p>
                )}
                {errors.street && errors.street.type === "maxLength" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-MaxLength150")}
                  </p>
                )}
              </div>
              <div className="form-row">
                <div className="form-group col-md-8">
                  <label htmlFor="streetNumber">
                    {translator("Onboarding-StoreData-StreetNumber")}
                  </label>{" "}
                  <Tooltip text={translator("StoreDataStreetNumber-Msg")} />
                  <input
                    type="text"
                    className="form-control"
                    name="streetNumber"
                    ref={register({
                      required: true,
                      pattern: numbersOnly,
                      maxLength: 6,
                    })}
                    defaultValue={createStoreData.streetNumber}
                  />
                  {errors.streetNumber &&
                    errors.streetNumber.type === "required" && (
                      <p className="text-danger">
                        {translator("ValidationMsg-RequiredField")}
                      </p>
                    )}
                  {errors.streetNumber &&
                    errors.streetNumber.type === "maxLength" && (
                      <p className="text-danger">
                        {translator("ValidationMsg-MaxLength6")}
                      </p>
                    )}
                  {errors.streetNumber &&
                    errors.streetNumber.type === "pattern" && (
                      <p className="text-danger">
                        {translator("ValidationMsg-NumberOnly")}
                      </p>
                    )}
                </div>
                <div className="form-group col-md-4">
                  <label htmlFor="storeStreetNumberExtension">
                    {translator("Onboarding-StoreData-StreetNumberAddition")}
                  </label>{" "}
                  <Tooltip
                    text={translator("StoreDataStreetNumberAddition-Msg")}
                  />
                  <input
                    type="text"
                    className="form-control"
                    name="streetNumberExtension"
                    ref={register({ maxLength: 10 })}
                    defaultValue={createStoreData.streetNumberExtension}
                  />
                  {errors.streetNumberExtension &&
                    errors.streetNumberExtension.type === "maxLength" && (
                      <p className="text-danger">
                        {translator("ValidationMsg-MaxLength10")}
                      </p>
                    )}
                </div>
              </div>
              <div className="form-row">
                <div className="form-group col-md-5 col-xs-12">
                  <label htmlFor="storePostalNumber">
                    {translator("Onboarding-StoreData-ZipCode")}
                  </label>{" "}
                  <Tooltip text={translator("StoreDataZipCode-Msg")} />
                  {postOffices.length !== 0 && (
                    <Controller
                      as={Select}
                      ref={register({
                        required: true,
                      })}
                      options={
                        postOffices &&
                        postOffices.map((p) => ({
                          id: p.id,
                          label: p.name,
                          value: p.name,
                        }))
                      }
                      name="postalNumber"
                      defaultValue={{
                        label: createStoreData.postalNumber,
                        value: createStoreData.postalNumber,
                      }}
                      control={control}
                      onChange={function (event) {
                        getCity(event[0].id, event[0].label);
                        return event[0];
                      }}
                    />
                  )}
                  {errors.city && errors.city.type === "required" && (
                    <p className="text-danger">
                      {translator("ValidationMsg-RequiredField")}
                    </p>
                  )}
                </div>
                <div className="form-group col-md-7 col-xs-12">
                  <label htmlFor="storeCity">
                    {translator("Onboarding-StoreData-City")}
                  </label>{" "}
                  <Tooltip text={translator("StoreDataCity-Msg")} />
                  <input
                    type="text"
                    className="form-control"
                    name="city"
                    ref={register({ required: true })}
                    defaultValue={createStoreData.city}
                    disabled
                  />
                </div>
              </div>
              <div className="form-group">
                <label htmlFor="countryId">
                  {translator("Onboarding-StoreData-State")}
                </label>
                {countries.length > 0 && (
                  <select
                    className="form-control"
                    name="countryId"
                    ref={register({ required: true })}
                    defaultValue={createStoreData.countryId}
                  >
                    {countries.map((e, key) => {
                      return (
                        <option selected={true} key={key} value={e.id}>
                          {e.name}
                        </option>
                      );
                    })}
                  </select>
                )}
                {errors.countryId && errors.countryId.type === "required" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-RequiredField")}
                  </p>
                )}
              </div>
            </div>
          </fieldset>
        </div>
      </div>
      <br />
      <div className="row">
        <div className="col-6">
          <button className="btn btn-outline-secondary" onClick={back}>
            {translator("Onboarding-Btn-Back")}
          </button>
        </div>
        <div className="col-6 text-right">
          <button className="btn btn-primary" onClick={handleSubmit(goTo)}>
            {translator("Onboarding-Btn-Next")}
          </button>
        </div>
      </div>
    </>
  );
};

export default StoreData;
